import './card-toolbar.scss';
import { ButtonIcon } from '../../../inputs/button-icon/button-icon';
import IconNext from '../../../icons/icon-next/icon-next';
import FontHeading3 from '../../../fonts/font-heading3/font-heading3';
import { FONT_VARIANT } from '../../../fonts/font-props';
import { CARD_SPACING_VARIANT } from '../card.types';

export interface CardToolbarProps {
    content?: React.ReactNode;
    title?: React.ReactNode;
    isExpandable?: boolean;
    isExpanded?: boolean;
    isExpandDisabled?: boolean;
    onExpandClick?: () => void;
    spacingVariant?: CARD_SPACING_VARIANT;
}


const CardToolbar = ({ content, title, isExpandable, isExpanded, isExpandDisabled, onExpandClick, spacingVariant = CARD_SPACING_VARIANT.DEFAULT }: CardToolbarProps) => {
    const handleClick = () => {
        if (isExpandable && !isExpandDisabled && onExpandClick) {
            onExpandClick();
        }   
    }


    return (
        <div className={`card-toolbar ${isExpanded ? 'expanded' : ''} ${isExpandable ? 'expandable' : ''} ${spacingVariant}`} onClick={handleClick}>
            <div className='card-toolbar-title'>
                <FontHeading3 variant={FONT_VARIANT.BOLD}>{title}</FontHeading3>
            </div>
            <div className='card-toolbar-content'>
                {content}
            </div>
            {isExpandable &&
                <div className={`expand-icon ${isExpanded ? 'expanded' : 'collapsed'}`}>
                    <ButtonIcon Component={IconNext} onClick={onExpandClick} disabled={isExpandDisabled} />
                </div>
            }
        </div>
    )
};

export default CardToolbar;
